/* unplugin-vue-components disabled */import script from "./ExtensionButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExtensionButton.vue?vue&type=script&lang=ts&setup=true"

import "./ExtensionButton.vue?vue&type=style&index=0&id=ed9c1b78&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed9c1b78"]])

export default __exports__